/*!
 * webmd.medscape - target and flight medscape ads to users on WebMD identified as medscape users.
 * https://confluence.webmd.net/pages/viewpage.action?spaceKey=ProfessionalDev&title=Target+medscape+users+on+webmd.com
 * https://confluence.webmd.net/pages/viewpage.action?pageId=19540841
 * https://jira.webmd.net/browse/PPE-56960
 * make a call to the api in medscape.com to get the user details and write the cookie with updated info.
 */

import debug from 'webmd-debug';
import cookie from 'webmd-cookie';
import { ua } from 'webmd-useragent';

let medscape;

if (typeof window !== 'undefined') {

	(function () {

		//PPE-324582 : Disable Vendor
		//Disable vendor if url containts vendor=0 or medscape=0
		var url = (document.referrer) ? document.referrer : document.location.href;
		if (url && (url.indexOf('vendor=0') > -1 || url.indexOf('med=0') > -1)) {
			return false;
		} 
		
		// Disable vendor based on ads admin tool data
		if(window.globalConfig && window.globalConfig.ads) {

			let vendorConfig = window.globalConfig.ads.vendorConfig;
			let medScapeConfig = vendorConfig.medScape ? vendorConfig.medScape : {};
			let location = cookie.getJson('gtinfo');
			
			/**
			 *  Gtinfo cookie stores country code in lowercase while admin tool db stores in uppercase
			 *  hence text transform is done.
			 */
			let isLocationAdded = false;
			let countryCode = location.cntr ? location.cntr.toUpperCase() : '';
			let locationList = medScapeConfig.location ? medScapeConfig.location : [];
																																																																		
			/** 
			 *  If the gtinfo is not available and only some of the locations are selelcted, 
			 *  location based vendor suppression cannot be done properly. Hence, vendors can be loaded 
			 *  as default behavior. 
			 * 
			 *  If location property is undefined or no countries are added in location array 
			 *  or all the countries are selected, then it can be considered as 
			 *  all the locations are selected and not required to check for gtinfo.
			 *  Countries available in WebMD gtinfo file : 249
			 */
			if ( !(countryCode == '' && locationList.length > 0 && locationList.length < 249) ) {
				if ( locationList.length == 0 || locationList.length == 249 || locationList.includes(countryCode) ) {
					isLocationAdded = true;
				}
				/**
				 *  If disable is true and the location is included in the location array, 
				 *  then vendor should not be loaded.   
				 *  If disable is set to false and certain countries are added in location array, 
				 *  then for the countries that are not added in the array can be considered 
				 *  to have disable : true and vendor should not be loaded in this case. 
				 */
				if (medScapeConfig.disable && isLocationAdded) {
					return false;
				} else if ( !(medScapeConfig.disable) && !isLocationAdded ) {
					return false;			
				}
			}
		}

		// if in iframe, exit;
		if (window.top !== window.self) {
			debug('medscape beacon not fired in iframe.');
			return false;
		}

		if (window.location.host.indexOf('member') > -1) {
			debug('medscape not fired for member pages');
			return false;
		}

		// allow other code to disable the beacon
		if (webmd.beaconDisable) {
			debug('Medscape beacon not fired due to beaconDisable.');
			return false;
		}

		// if we are on sensitive topic pages
		if (window.s_sensitive && window.s_sensitive === "true") {
			return false;
		}

		// we need to exclude fit, so doing a simple match on "fit." in the hostname
		if (window.location.hostname.indexOf('fit.') > -1) {
			debug('medscape beacon not fired on Fit');
			return false;
		}

		// we need to not fire these beacons on iOS or inside the WebMD app
		if (ua.appview) {
			debug('medscape beacon not fired in WebMD App');
			return false;
		}
	}());

	medscape = {

		/*
		 * medscape cookie
		 */
		medat: cookie('medat'),

		/*
		 * a list key definitions for custom params we want to set in dfp.
		 */
		dfp_params_to_set: ['occ', 'ct', 'pf', 'st', 'tar', 'usp', 'tc', 'gd', 'dt', 'actid'],

		/*
		 * the amount of time we will wait to get a response from the medscape API
		 */
		timeout: 600,

		init: function () {
			var
				cookieParts,
				options,
				self = this;

			/*
			 * check if a medat cookie exists, if it does not, do nothing.
			 * if it does, then check if it is more than 60 minutes old and refresh the cookie if it is.
			 */
			if (this.medat) {
				cookieParts = this.parseCookie(this.medat, '&');

				// get the values we need from the cookie
				options = this.pluck(cookieParts);

				// set custom params
				if (!webmd.isIE9AndBelow) {
					window.webmd.ads.setPageTarget(options);

				}

				// refresh the medscape cookie if it is more than 1 hour old.
				if (cookieParts.date && new Date() - new Date(cookieParts.date) > (60 * 60 * 1000)) {
					/**
					 * performance mark to spot when medscape cookie refreshes
					 */
					try {
						window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-medscape-medat", "webmd-medscape-medat-cookie-expired");
						window.performance.mark("medscape-refresh-start");
						window.performance.measure('measure-medscape-refresh-start', 'ads-code-load', 'medscape-refresh-start');
						debug('(Perf-Mark) Medscape refresh starts -> ' + window.performance.getEntriesByName('measure-medscape-refresh-start', 'measure')[0].duration);

					} catch (e) {
						debug(e)
					}
					
					debug('refreshing medscape cookie...');
					var xhr = new XMLHttpRequest();
					var url = 'https://api.medscape.com/servicegateway/medscapeuserdata';
					if(window.location.href.indexOf('qatest')> -1){
						url = 'https://api.qa01.medscape.com/servicegateway/medscapeuserdata';
					}
					if(window.location.href.indexOf('mstest')  > -1){
						url = url + '?medscapetest=1'
					}
					if(window.location.href.indexOf('mstimeout') > -1){
						self.timeout = 1500;
					}
					xhr.open('GET', url);
					xhr.withCredentials = true;
					xhr.setRequestHeader('x-user-token',  cookieParts.authtoken || '');
					xhr.timeout = self.timeout;
					xhr.send();
					xhr.onreadystatechange = function () {
						if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
							// Request finished. Do processing here.
							this.refreshMedscapeCookie(this.responseText);
						} else if (this.readyState == XMLHttpRequest.DONE && this.status != 200) {
							debug('MEDSCAPE CONNECTION FAILED: ' + this.responseText);
							window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-medscape-medat", "webmd-medscape-medat-service-connection-failed");
						}
					}
					xhr.ontimeout = function (e) {
						debug('MEDSCAPE API REQUEST TIMED OUT');
						window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-medscape-medat", "webmd-medscape-medat-service-timeout");
						debug(e);
					}
				}
			} else {
				debug('medscape cookie not needed.');
			}
		},
		/*
		 * get a subset of an object containing custom params we want to set in DFP.
		 * @param {Object} obj: An object containing key/value pairs.
		 * @return {Object} a dictionary containing custom parameters to set in DFP.
		 */
		pluck: function (obj) {
			var
				options = {},
				key;

			for (key in obj) {
				if (this.dfp_params_to_set.includes(key)) {
					options[key] = obj[key];
				}
			}

			return options;
		},
		/*
		 * split a cookie string into key/value pairs
		 * @example
		 * "guid=591884712&tar=[]&ct=us&pf=10&occ=0&tac=[]&st=ny&ps=32" becomes
		 * {"guid":"591884712", "tar":"[]", "ct":"us", "pf":"10", "occ": "0", "tac":"[]", "st":"ny", "ps":"32"}
		 *
		 * @str {String} str: A delimeted string
		 * @delimeter {String} delimeter: A string used to separate parameters
		 * @return {Object} an object containing key/value pairs.
		 */
		parseCookie: function (str, delimeter) {
			var
				o,
				j,
				i,
				l,
				options = {};

			o = str.split(delimeter);
			l = o.length;

			for (i = 0; i < l; i++) {
				j = o[i].split('=');

				if (j[0]) {
					options[[j[0]]] = j[1] || '';
					options[[j[0]]] = options[[j[0]]].replace(/,\s+/g, ',');
				}
			}

			return options;
		},

		refreshMedscapeCookie: function (d) {
			if (d) {
				/*
				 * medscape calls out to an external API to get tac info.
				 * sometimes that external API request times out and tac parameter is returned in the
				 * medscape API response as an empty array; i.e "guid=591959259&tl=[]&c=us&p=20&o=1014&tac=[]&..."
				 * to help performance, we save the value of the tac parameter in the cookie prior to calling the medscape API,
				 * and we set this value in the updated medscape cookie if tac is empty in the api response.
				 */
				var tac = cookieParts.tc;
				var responseBackup = d;
				responseBackup = responseBackup.split("&");
				for (let i=0 ;i<responseBackup.length; i ++){
					if(responseBackup[i].includes("actid")){
						responseBackup[i] = responseBackup[i].replace("[","").replace("]","")
					}
				}
				if(responseBackup && responseBackup.length){
					responseBackup.join("&").toString();
				}
				d = responseBackup;
				if (d.match(/tac=\[\]/)) {
					d = d.replace(/tac=\[\]/, "tac=" + tac);
					d = d.replace(/actid=\[\]/, "actid=" + cookieParts.actid);
				}
				// refresh the medscape cookie with latest user info
				var iframeMedscapeBeacon = document.createElement("iframe");
				iframeMedscapeBeacon.setAttribute('id', 'medscapeBeacon');
				iframeMedscapeBeacon.setAttribute('src', '//img.webmd.com/medscape/medscapebeacon.html?' + d);
				iframeMedscapeBeacon.setAttribute('style', 'width:0px; height:0px; border:0px;');
				document.body.appendChild(iframeMedscapeBeacon);
				iframeMedscapeBeacon.onload = function () {
					/**
					 * performance mark to spot when medscape cookie refreshes
					 */
					try {
						window.performance.mark("medscape-cookie-refreshed");
						window.performance.measure('measure-medscape-cookie-refreshed', 'ads-code-load', 'medscape-cookie-refreshed');
						debug('(Perf-Mark) Medscape cookie refreshed -> ' + window.performance.getEntriesByName('measure-medscape-cookie-refreshed', 'measure')[0].duration);
					} catch (e) {
						debug(e)
					}
					
				};
				iframeMedscapeBeacon.onerror = function() {
					window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-medscape-medat", "webmd-medscape-medat-refresh-failed");
					debug('medscape cookie not refreshed on error');
					reject();
				}
			} else {
				debug('==== empty response from medscape API ====');
			}
		}
	};

	/**
	* we need to load medscape once __tcfapiPromise is resolved,
    * the Promise is resolved once tcfapi.js is loaded onto the page
    * 
    * tcfapi.js is loaded only in EU locations and in other locations the Promise is
    * resolved immediately (handled in IAB stub code - webmd-ccm.js)
    */
	Promise.resolve(window.__tcfapiPromise).then(function () {
		medscape.init();
	});

}
